module.exports = __webpack_public_path__ + "logo.png?82ec04b48f9baf069a5cb775477c41ee";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.png
// module id = 242
// module chunks = 0